<template>
    <div class="l-row l-row--center">
        <div class="l-row__column l-row__column--11">
            <div class="o-dashboardOffer a-mobile">
                <div v-if="offersStatus === 'pending'">
                        <a-icon icon="Spinner" />
                </div>
                <template v-else-if="offers && offers.length > 0">
                    <p
                        class="a-price a-price--left a-text--bold a-price--big"
                        id="offersList"
                    >
                        Lista ofert
                    </p><br />
                    <div class="o-dashboardOffer__table">
                        <div class="o-dashboardOffer__row">
                            <div class="o-dashboardOffer__item">
                                <p class="a-text a-text--bold a-text--gray o-dashboardOffer__content">
                                    Nazwa
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text a-text--bold a-text--gray o-dashboardOffer__content">
                                    Okres dostaw
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text a-text--bold a-text--gray o-dashboardOffer__content">
                                    Data utworzenia
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text a-text--bold a-text--gray o-dashboardOffer__content">
                                    Ważna do
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text a-text--bold a-text--gray o-dashboardOffer__content">
                                    Status
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text a-text--bold a-text--gray o-dashboardOffer__content">
                                    Akcje
                                </p>
                            </div>
                        </div>
                        <div
                            class="o-dashboardOffer__row"
                            v-for="offer in offers"
                            v-bind:key="offer.slug"
                        >
                            <div class="o-dashboardOffer__item">
                                <p class="a-text o-dashboardOffer__content" data-name="nazwa">
                                    {{ offer.name }}
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p
                                    v-if="offer.period"
                                    class="a-text o-dashboardOffer__content" data-name="okres dostaw"
                                >
                                    {{ offer.period }}
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text o-dashboardOffer__content" data-name="data utworzenia">
                                    {{ moment(offer.created_at).format('DD.MM.YYYY') }}
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text o-dashboardOffer__content" data-name="ważna do">
                                    {{ offer.valid_yet }}
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item">
                                <p class="a-text o-dashboardOffer__content" data-name="status">
                                    {{ offer.status.name }}
                                </p>
                            </div>
                            <div class="o-dashboardOffer__item o-dashboardOffer__item--actions">
                                <button
                                    v-if="pdfStatus !== `pending${offer.name.replace(/\//g, '-')}`"
                                    class="a-button o-dashboardOffer__button o-dashboardOffer__content"
                                    @click="fetchPdf({
                                        name: offer.name,
                                        slug: offer.slug
                                    })"
                                >
                                    <a-icon class="a-icon" icon="Eye" />
                                    <span class="o-dashboardOffer__buttonText">Zobacz</span>
                                </button>
                                <div v-else>
                                    <a-icon icon="SpinnerSmall" />
                                </div>
                                <button
                                    v-if="offer.to_accept"
                                    class="a-button o-dashboardOffer__button o-dashboardOffer__content"
                                    @click="$router.push({
                                        name: 'offer-cart',
                                        params: {
                                            slug: offer.slug
                                        }
                                    })"
                                >
                                    <a-icon class="a-icon" icon="Checkmark" />
                                </button>
                                <button
                                    v-if="offer.to_reject"
                                    class="a-button o-dashboardOffer__button o-dashboardOffer__content"
                                    @click="rejectOfferModal(offer.slug)"
                                >
                                    <a-icon class="a-icon" icon="Cancel" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="o-dashboardInvoices__pagination"
                        v-if="offersPaginationTotal > 1"
                    >
                        <a-button
                            class="o-dashboardInvoices__paginationItem"
                            :selected="page === offersPaginationCurrent"
                            @click="setPage(page)"
                            v-for="page in offersPaginationTotal"
                            v-bind:key="page"
                        >
                            {{ page }}
                        </a-button>
                    </div>
                </template>
                <div v-else>
                    <p class="a-price a-price--left a-text--bold a-price--big">
                        Brak ofert
                    </p>
                </div>
            </div>
        </div>
        <o-modal name="rejectOffer">
            <template slot="content">
                <p class="a-text a-text--big a-text--center">
                    Podaj powód odrzucenia oferty:
                    <br /><br />
                    <a-control
                        placeholder="Powód odrzucenia oferty"
                        :id="`control-offer-reject`"
                        type="textarea"
                        rows="4"
                        v-model="rejectReason"
                    />
                </p>
                <br />
                <div class="a-mobile__buttons">
                    <a-button
                        class="a-button a-mobile__button"
                        @click="$store.dispatch('modalHide')"
                    >Powrót</a-button>
                    &nbsp;
                    <a-button
                        class="a-button a-button--secondary a-mobile__button"
                        @click="rejectOffer(modalPayload.slug)"
                    >Odrzuć ofertę</a-button>
                </div>
            </template>
        </o-modal>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            rejectReason: ''
        }
    },
    computed: {
        offers() {
            return this.$store.getters['offers/list']
        },
        offersStatus() {
            return this.$store.getters['offers/status']
        },
        pdfStatus() {
            return this.$store.getters['offers/pdfStatus']
        },
        offersPaginationTotal() {
            return this.$store.getters['offers/paginationTotal']
        },
        offersPaginationCurrent() {
            return this.$store.getters['offers/paginationCurrent']
        },
        modalPayload() {
            return this.$store.getters.modalPayload || {}
        }
    },
    methods: {
        moment(date) {
            return moment(date).locale('pl')
        },
        fetchPdf(payload) {
            this.$store.dispatch('offers/fetchPdf', payload)
        },
        fetchOffers() {
            return this.$store.dispatch('offers/fetchList')
        },
        setPage(page) {
            this.$store.dispatch('offers/setListPage', page)
            this.fetchOffers().then(() => {
                // scroll to invoices
                this.$scrollTo('#offersList', 500, {
                    offset: -110
                })
            })
        },
        rejectOfferModal(slug) {
            this.$store.dispatch('modalHide')
            this.$store.dispatch('modalShow', {
                name: 'rejectOffer',
                payload: {
                    slug
                }
            })
        },
        rejectOffer(slug) {
            this.$store.dispatch('rejectOffer', {
                slug,
                reason: this.rejectReason
            }).then(() => {
                this.$store.dispatch('modalHide')
                this.$router.push({ name: 'dashboard-offer-thank-you-reject' })
            })
        }
    },
    created() {
        this.fetchOffers()
    }
}
</script>
